import React from 'react'
import PropTypes from 'prop-types'
import { Grid } from '@mui/material'

import './style.scss'

export const PageLeft = ({ isVisible, children }) => (
  <Grid
    item={true}
    xs={true}
    className="commonPage_container_lateral left"
    style={{ display: isVisible ? 'block' : 'none' }}
  >
    {children}
  </Grid>
)

PageLeft.propTypes = {
  children: PropTypes.node.isRequired,
  isVisible: PropTypes.bool
}

PageLeft.defaultProps = {
  isVisible: true
}
